// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b9l7","index":"styles_index__1Ry7K"};